<app-dialog [dialogTitle]="title">
  <app-dialog-content>{{ message }}</app-dialog-content>
  <app-dialog-actions>
    <app-button [variant]="confirmButtonVariant" mat-dialog-close>
      {{ confirmButtonText || ('public.dialog.ok' | translate) }}
    </app-button>
  </app-dialog-actions>
</app-dialog>
